import { render, staticRenderFns } from "./values-object.vue?vue&type=template&id=900f9432&scoped=true"
import script from "./values-object.vue?vue&type=script&lang=js"
export * from "./values-object.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900f9432",
  null
  
)

export default component.exports